import React from 'react'
import { useIntl } from 'react-intl'

import AlertDialog from './AlertDialog'
import AlertToast from './AlertToast'

import alertList from '../../constants/alertList'

export default function AlertFactory(props) {
    const intl = useIntl()
    const {
        errorKey,
        replaceArgs,
        action1,
        action2,
        timestap,
        closeCurrentErrorMessage,
    } = props

    let errorContent = { ...alertList[errorKey] }

    if (errorContent === undefined) {
        return ''
    }

    if (errorContent.type === 'special') {
        return ''
    }

    // i18n
    if (errorContent.title) {
        errorContent.title = intl.formatMessage({
            id: errorContent.title,
        })
    }
    if (errorContent.content) {
        errorContent.content = intl.formatMessage({
            id: errorContent.content,
        })
    }
    if (errorContent.action1Text) {
        errorContent.action1Text = intl.formatMessage({
            id: errorContent.action1Text,
        })
    }
    if (errorContent.action2Text) {
        errorContent.action2Text = intl.formatMessage({
            id: errorContent.action2Text,
        })
    }

    if (Object.keys(replaceArgs).length > 0) {
        Object.keys(replaceArgs).forEach((key) => {
            if (errorContent.title) {
                errorContent.title = errorContent.title.replace(
                    new RegExp(`{{${key}}}`),
                    replaceArgs[key]
                )
            }
            errorContent.content = errorContent.content.replace(
                new RegExp(`{{${key}}}`),
                replaceArgs[key]
            )
        })
    }

    function handleAction1() {
        action1()
    }

    function handleAction2() {
        action2()
    }

    if (errorContent.type === 'dialog') {
        return (
            <AlertDialog
                timestap={timestap}
                title={errorContent.title}
                content={errorContent.content}
                action1={handleAction1}
                action2={handleAction2}
                action1Text={errorContent.action1Text}
                action2Text={errorContent.action2Text}
                closeCurrentErrorMessage={closeCurrentErrorMessage}
            />
        )
    }
    if (errorContent.type === 'toast') {
        return (
            <AlertToast
                timestap={timestap}
                content={errorContent.content}
                close={closeCurrentErrorMessage}
            />
        )
    }

    return ''
}
